<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h5 class="mb-0">
                Filters
            </h5>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form class="">
            <app-search-input
                [label]="'Id'"
                type="number"
                (searchEvent)="onSearchId(+($event))"
                [value]="updatedFilters.id === 0 ? '' : updatedFilters.id"
            ></app-search-input>
            <app-sw-reset-option
                (selectionChangedEvent)="onSeverityChange($event)"
                [label]="'Severity'"
                [data]="severityList"
                [value]="updatedFilters.severity.toString()"
            ></app-sw-reset-option>
            <div class="d-flex dates">
                <app-date-picker
                    [label]="'Start Date'"
                    (changeDateEvent)="onStartDateChange($event)"
                    [dateControl]="formatedStartDate"
                ></app-date-picker>
                <app-date-picker
                    [label]="'End Date'"
                    (changeDateEvent)="onEndDateChange($event)"
                    [dateControl]="formatedEndDate"
                ></app-date-picker>
            </div>
            <app-search-input
                [label]="'Source Context'"
                (searchEvent)="onSearchSourceContext($event)"
                [value]="updatedFilters.sourceContext"
            ></app-search-input>
            <app-search-input
                [label]="'Filter'"
                (searchEvent)="onSearchFilter($event)"
                [value]="updatedFilters.filter"
            ></app-search-input>
            <app-search-input
                [label]="'Method'"
                (searchEvent)="onSearchMethod($event)"
                [value]="updatedFilters.method"
            ></app-search-input>
            <div class="d-flex buttons">
                <button
                    mat-raised-button
                    class="daxa"
                    (click)="applyFilters($event)"
                >
                    Apply
                </button>
                <button
                    mat-raised-button
                    class="daxa"
                    (click)="resetFilters($event)"
                >
                    Reset
                </button>
                <button mat-raised-button color="warn" (click)="cancel($event)">
                    Cancel
                </button>
            </div>
        </form>
    </mat-card-content>
</mat-card>
